import {
    REDIRECT_CORP_CHOOSE,
    REDIRECT_CORP_CHOOSE_RESET,
    REDIRECT_SIGN_IN,
    REDIRECT_SIGN_IN_RESET
} from "./constants";

//
export const RedirectSignInReducer = (state = {}, action) => {
    let ret = {
        ...state,
        idKey: Math.random()
    }
    const data = action.payload;
    switch (action.type) {
        case REDIRECT_SIGN_IN_RESET:
            ret.from = '';
            ret.redirect = null;
            break;
        case REDIRECT_SIGN_IN:
            ret.from = data.from;
            ret.redirect = true;
            break;
        default:
            return {...state};
    }
    return ret;
}

//
export const RedirectCorpChooseReducer = (state = {}, action) => {
    let ret = {
        ...state,
        idKey: Math.random()
    }
    const data = action.payload;
    switch (action.type) {
        case REDIRECT_CORP_CHOOSE_RESET:
            ret.from = '';
            ret.redirect = null;
            break;
        case REDIRECT_CORP_CHOOSE:
            ret.from = data.from;
            ret.redirect = true;
            break;
        default:
            return {...state};
    }
    return ret;
}